<template>
  <div>
    <n-space>
      <div class="clockText">
        {{ digitConvert(dateTime.hours) }}:{{
          digitConvert(dateTime.minutes)
        }}:{{ digitConvert(dateTime.seconds) }}
      </div>
      <iframe
        src="https://giphy.com/embed/Q8fe4Gyb7th7nv3mCG"
        width="30"
        height="30"
        frameBorder="0"
        class="giphy-embed"
        allowFullScreen
      ></iframe>
    </n-space>
  </div>
</template>
<script>
const date = new Date();
export default {
  name: 'App',
  data() {
    return {
      dateTime: {
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
      },
      timer: undefined,
    };
  },
  methods: {
    setDateTime() {
      const date = new Date();
      this.dateTime = {
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
      };
    },
    digitConvert(number) {
      return (number < 10 ? '0' : '') + number;
    },
  },
  beforeMount() {
    this.timer = setInterval(this.setDateTime, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>
<style>
.clockText {
  color: crimson;
  font-size: 20px;
}
</style>
